// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./assessment"
import "./assessment_show"
import "./seo_assessment"
import "./seo_results"
import "./ux_assessment"
import "./ux_results"
import "./contact_form"
import "./reviews_carousel"
import "./faq"
import "./av_countdown"
import "./seo_geo_competitor_report"
import "./vs_video"
import { captureUtmParamsFromLocation } from "./lib/utm_tracking"

// Nav scroll-to CTAs
function initNavCtas() {
  document.querySelectorAll("[data-scroll-to]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = document.querySelector(btn.dataset.scrollTo);
      if (!target) return;
      const navH = document.querySelector(".site-nav")?.offsetHeight ?? 0;
      const top  = target.getBoundingClientRect().top + window.scrollY - navH;
      window.scrollTo({ top, behavior: "smooth" });
    });
  });
}

// Close hamburger menu when a nav link is clicked
function initNavToggle() {
  const toggle = document.getElementById("nav-toggle");
  if (!toggle) return;
  document.querySelectorAll(".nav-menu .nav-link").forEach((link) => {
    link.addEventListener("click", () => { toggle.checked = false; });
  });
}

function initApplication() {
  captureUtmParamsFromLocation();
  initNavCtas();
  initNavToggle();
}

document.addEventListener("turbo:load", initApplication);
if (document.readyState !== "loading") initApplication();
